import { render, staticRenderFns } from "./SitemapController.vue?vue&type=template&id=77621748&scoped=true&"
import script from "./SitemapController.vue?vue&type=script&lang=ts&"
export * from "./SitemapController.vue?vue&type=script&lang=ts&"
import style0 from "./SitemapController.vue?vue&type=style&index=0&id=77621748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77621748",
  null
  
)

export default component.exports